import styled from 'styled-components';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Fade, Zoom } from 'react-reveal';
import { Link } from 'react-router-dom';
function EventsCard(props) {
  
  return (
    <Link to={`../${props.LinkID}`}>
      <Card>
        <Zoom>
          <img src={props.image} alt="" />
        </Zoom>
        <h1 className='h1 text-center font-weight-bold'>{props.title}</h1>
        <p><span> <AccessTimeIcon/></span> {props.time}</p>
        <p><span> <CalendarTodayIcon/></span> {props.date}</p>
        <p><span> <LocationOnIcon/></span> {props.location} </p>
    </Card>
      
    </Link>

  )
}

export default EventsCard
const Card = styled.div` 
/* background:#f6f6f6 ; */
padding-bottom:10px ;
box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
transition:.3s;
&:hover{
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
  transform:translateY(-10px) ;
}
img{
    width:100% ;
    height:250px ;
    object-fit:cover ;
}
h1{
    font-family:Arial, Helvetica, sans-serif ;
    font-size:1.5em ;
    padding:10px ;
    color: black;
}
p{
    padding-left:10px ;
    margin-left:15px ;
}
span{
  color:#fa7525;
}
`
